{
	"savingsToBeAssured": "Carbon reductions to be assured",
	"newCycles": "New cycles",
	"inValidation": "Cycles in validation"
}
